module.exports = __webpack_public_path__ + "img/52.4efa8351.svg";